import { ProductItemFormData } from "../types/products";
import { BatchCreateResult } from "../types/productItemWizard";

export type CreateProductItemFn = (input: {
  productItem: ProductItemFormData;
}) => Promise<string | null>;

/**
 * Creates N product items with identical specs using parallel single-create calls.
 */
export async function createProductItemsInBatch(
  createProductItem: CreateProductItemFn,
  formData: ProductItemFormData,
  quantity: number
): Promise<BatchCreateResult> {
  const settled = await Promise.allSettled(
    Array.from({ length: quantity }, () =>
      createProductItem({ productItem: formData })
    )
  );

  const createdIds: string[] = [];
  settled.forEach((result) => {
    if (result.status === "fulfilled" && result.value != null) {
      createdIds.push(result.value);
    }
  });

  return {
    createdIds,
    failedCount: quantity - createdIds.length,
    totalRequested: quantity
  };
}
